import type { Messages } from "./en";
import { evidenceZhCN } from "./evidence";

export const zhCN = {
  evidence: evidenceZhCN,
  brand: { name: "CAYLET", tool: "IP 检测" },
  nav: {
    check: "IP 保护检测",
    how: "原理解析",
    esim: "自研eSIM",
    articles: "科普文章",
    main: "Caylet.com",
    language: "选择语言",
    languageCodes: { en: "EN", zhCN: "简", zhTW: "繁" },
    languageNames: { en: "English", zhCN: "简体中文", zhTW: "繁體中文" }
  },

  scanner: {
    title: "IP 信誉与网络环境检测",
    body: "Cloudflare 会观察本次请求使用的连接；启用 Scamalytics 后，同一个公网 IP 会发送给该服务以查询信誉。",
    start: "开始 IP 检测",
    rescan: "再次检测",
    loadingLocal: "正在读取浏览器提供的信息…",
    loadingNetwork: "正在请求网络观察结果…",
    complete: "检测完成",
    partial: "检测完成，部分字段不可用",
    consent: "本页面在加载时会通过 Cloudflare 连接信息自动对你当前的公网 IP 进行检测。",
    privacy: "检测结果仅保留在当前标签页内存中，且不会因切换语言而重新请求。",
    statusSafe: "检测完成；当前可用数据未发现明显警示。",
    statusWarning: "环境参数检测完成，侦测到中度网络风控风险。",
    statusDanger: "环境参数检测完成，侦测到高度网络风控风险。"
  },
  common: {
    unavailable: "不可用",
    yes: "是",
    no: "否",
    unknown: "未知",
    approximate: "近似",
    observed: "已观察到",
    notObserved: "未观察到",
    close: "关闭"
  },
  cards: {
    dashboardTitle: "网络环境与设备综合检测仪表盘",
    dashboardSub: "GLOBAL NETWORK & ENVIRONMENT DIAGNOSTIC MATRIX",
    connection: "连接概览",
    connectionSub: "CONNECTION SUMMARY",
    reputation: "IP 信誉",
    reputationSub: "IP REPUTATION",
    browser: "浏览器环境",
    browserSub: "BROWSER ENVIRONMENT",
    hardware: "硬件与系统规格",
    hardwareSub: "HARDWARE & SYSTEM SPECIFICATIONS",
    protocol: "协议观察",
    protocolSub: "PROTOCOL OBSERVATIONS",
    ip: "公网 IP",
    family: "IP 类型",
    location: "IP 所在地",
    asn: "ASN",
    organization: "机构",
    ipTimezone: "IP 所在时区",
    score: "IP 欺诈值",
    band: "风险评级",
    flags: "供应商标记",
    providerTime: "数据时间",
    abuseScore: "公网威胁置信度",
    abuseReports: "公网恶意举报次数",
    proxy: "代理",
    vpn: "VPN",
    tor: "Tor",
    datacenter: "数据中心",
    deviceTimezone: "设备时区",
    language: "浏览器语言",
    browserName: "浏览器",
    os: "操作系统",
    screen: "屏幕",
    cores: "CPU 逻辑核心数",
    currentFamily: "当前连接类型",
    webrtc: "WebRTC 观察",
    noAdditionalIp: "本次测试未观察到额外公网 IP",
    additionalIp: "WebRTC 观察到额外公网 IP，请结合路由环境检查：",
    unsupported: "此浏览器未提供所需的 WebRTC 接口。",
    connectionAttribute: "IP 所在地区",
    verifiedUS: "连接特征：美国地区 (US)",
    verifiedNonUS: "连接特征：非美国地区",
    nodeAssessment: "节点特征",
    nodeClear: "[未见标记] 当前可用供应商字段均为否",
    nodeRisk: "[警示] 代理/机房节点",
    tzConsistency: "时区一致性",
    tzMatch: "[正常] 时区参数符合",
    tzMismatch: "[警示] 检测到时区不一致",
    gpu: "显示芯片 (GPU)",
    gpuStatus: "GPU 渲染器分类",
    gpuUnclassified: "[已观察] 已取得渲染器，硬件类型未经验证",
    virtualGpu: "[警示] 虚拟机 / 云端模拟器 GPU",
    webdriver: "自动化操控标记",
    webdriverDetected: "[警告] 自动化操控特征 (WebDriver)",
    webdriverNotExposed: "[已观察] 未暴露 WebDriver 标记",
    pingTest: "网络延迟测试 (Ping)",
    pingTestSub: "CONNECTION LATENCY",
    pingFast: "极速",
    pingGood: "良好",
    pingSlow: "缓慢",
    pingFailed: "超时",
    pingUnit: "毫秒",
    pingTargets: {
      cloudflareEdge: "Cloudflare 边缘网络",
      cayletApi: "Caylet API"
    },
    pingMethod: "测量此浏览器到 Caylet Cloudflare 边缘网络与 Worker 的同源 HTTPS 往返时间，并非 ICMP Ping。",
    pingExplanationLabel: "解释网络延迟测量方式",
    pingExplanation: "浏览器会向当前 Caylet 网站发送两个不会使用缓存的小型 HTTPS 请求。“Cloudflare 边缘网络”测量静态文件请求，“Caylet API”测量 Worker 健康检查接口。从发出请求到收到响应所经过的网络路由、HTTPS、Cloudflare 和 Worker 处理时间都会计入结果。浏览器无法发送 ICMP 回显数据包，因此这里的数值可能高于命令行 Ping，只应作为网页响应延迟的近似参考。",
    fraudCard: {
      eyebrow: "COMPREHENSIVE ASSESSMENT",
      title: "IP 欺诈值",
      bandLow: "低风险",
      bandMedium: "中等风险",
      bandHigh: "高风险",
      colSource: "数据来源",
      colValue: "参数",
      colStatus: "评估",
      statusLow: "✓ 低风险",
      statusMedium: "⚠ 中等",
      statusHigh: "✗ 高风险",
      proxyYes: "数据库确认 · 代理标记",
      proxyNo: "未发现 · 代理标记",
      asnHosting: "✗ 机房/数据中心",
      asnIsp: "仅供参考 · 不作欺诈结论",
      osintEntries: "条 Feodo 名单记录已检查",
      osintMatch: "数据库确认 · 命中僵尸网络 C2",
      osintNoMatch: "未发现 · 仅限此名单",
      evidenceNoData: "没有数据",
      note: evidenceZhCN.reputationNote,
      authScamalytics: "（IP 信誉分数来源）",
      authIp2Location: "（代理属性来源）",
      authAbuseIPDB: "（社区滥用评分来源）",
      authIpinfo: "（仅作 ASN 参考）",
      authOsint: "（僵尸网络 C2 名单 · CC0 OSINT）",
      providerInfoLabel: "了解 {provider} 的作用以及 Caylet 为什么采用它",
      providerInfo: {
        scamalytics: {
          title: "Scamalytics 是做什么的？",
          body: evidenceZhCN.reputationNote
        },
        ip2location: {
          title: "IP2Location 是做什么的？",
          body: "作用：IP2Location 提供 IP 地理位置与网络资料，以及当前可用方案所返回的代理属性。\n\n采用原因：Caylet 将代理属性作为独立的分类交叉检查，不会把它加入综合数值。没有代理标记也不能证明该 IP 一定没有使用代理。"
        },
        abuseIpDb: {
          title: "AbuseIPDB 是做什么的？",
          body: evidenceZhCN.abuseNote
        },
        ipinfo: {
          title: "IPinfo.io 是做什么的？",
          body: "作用：IPinfo Lite 提供基本的网络归属背景，包括自治系统编号（ASN）和 AS 组织名称。\n\n采用原因：ASN 可以帮助说明由哪个网络宣告该 IP。Caylet 不会把 Lite 结果当作欺诈分数，也不会将其加入综合数值。"
        },
        abuseCh: {
          title: "abuse.ch 是做什么的？",
          body: "作用：abuse.ch 的 Feodo Tracker 发布推荐封锁名单，列出与其追踪的僵尸网络命令与控制（C2）基础设施有关的 IP。\n\n采用原因：Caylet 在服务器端下载该名单并进行本地精确匹配。命中是范围有限的正面风险证据；未命中仅表示不在这份名单中，并不能证明安全。此结果不计入综合数值。"
        }
      }
    },
    descriptions: {
      connection: "分析由 Cloudflare 边缘网络侦测到的网络连接特征，包含公网 IP 地址、协议版本 (IPv4/IPv6)、地理位置、自治系统 (ASN) 及 ISP 运营商信息。地理位置为基于网络出口节点的估计值。",
      reputation: "展示可取得的 Scamalytics 信誉分数和供应商可选标记。缺失标记保持未知；否定或缺失标记不能证明 IP 安全。Caylet 综合评分会另行标示。",
      browser: "读取浏览器端公开的设备特征（如时区、语言、操作系统、屏幕分辨率与 CPU 核心数），并交叉比对“设备时区”与“IP 所在地时区”是否一致。Caylet 仅在内存中比对，绝不建立持久设备指纹。",
      protocol: "观察当前连接使用的 IP 协议类型，并通过标准 WebRTC 接口进行边界测试，确认是否存在额外的公网 IP 或路由差异。"
    }
  },
  risk: {
    low: "低",
    medium: "中",
    high: "高",
    unknown: "未知",
    lowText: "在可用的供应商结果中，未发现明显的公网 IP 信誉警示。",
    mediumText: "供应商结果包含需要结合使用场景查看的信号。",
    highText: "供应商结果包含较高的公网信誉信号。",
    unknownText: "目前无法取得信誉评估。",
    cayletNote: "风险评级由 Caylet 依据数据综合评估，非第三方官方唯一标准。"
  },
  diagnostics: {
    title: "金融风控综合一致性诊断",
    noAnomaly: "[未见明显警示] 当前可用检测结果一致",
    incomplete: "[数据覆盖不完整] 部分检测项目不可用",
    mediumRisk: "[中度审视] 包含需结合场景查看的信号",
    highRisk: "[高度警示] 检测到显著风控矛盾信号",
    chipTzMatch: "时区符合",
    chipTzMismatch: "时区不符",
    chipGpuUnclassified: "GPU 类型未经验证",
    chipGpuVirtual: "云端模拟器 GPU",
    chipWebDriverNotExposed: "未暴露 WebDriver",
    chipWebDriverDetected: "自动化脚本",
    chipThreatClear: "可用数据未见标记",
    chipThreatUnknown: "威胁检测数据不完整",
    chipThreatFlagged: "有威胁警报"
  },
  interpretation: {
    eyebrow: "风险背景",
    title: "结合实际情境阅读数据",
    body: "这些观察描述的是公开网络特征，而不是你的身份或金融机构对你的信任判断。",
    corePrinciple: "金融机构通常不会因为某一个信号异常，就直接认定账户被盗。真正重要的是多个信号之间是否互相一致，以及这次操作是否符合客户过往行为。IP 地址、地理位置、设备数据等单一信号本身不足以作为可靠的身份验证手段；但与设备信任、行为分析和交易监控结合后，就能成为有效的风险控制。",
    signalWeightsTitle: "信号的相对权重",
    signalTiers: [
      {
        label: "高权重信号",
        signals: [
          "已知且可信的设备 + App/操作系统完整性",
          "Passkey 或硬件安全密钥",
          "IP 具有滥用、代理或匿名服务记录",
          "不可能旅行（如几分钟内跨越两个国家）",
          "Session Token 从陌生位置被重放",
          "登录后执行敏感操作（新增收款人、大额转账）",
          "检测到远程控制或自动化操作",
          "与账户长期历史一致"
        ]
      },
      {
        label: "中等权重信号",
        signals: [
          "IP 所在国家与城市（尤其是首次出现的国家）",
          "ASN 类型（住宅、移动、机房、VPN）",
          "全新浏览器或操作系统",
          "登录时间异常",
          "时区不一致",
          "设备语言突然改变",
          "行为生物特征偏差",
          "Session 中 IP 快速轮换"
        ]
      },
      {
        label: "低权重（但可叠加）",
        signals: [
          "单独的屏幕分辨率或字体列表",
          "单独的非美国时区",
          "单独的海外 IP（真实旅行不等于欺诈）",
          "单独的浏览器版本变更",
          "单独使用公共 Wi-Fi"
        ]
      }
    ],
    networkTitle: "各种网络环境的风险参考",
    networkEnvironments: [
      { label: "家庭住宅宽带", risk: "低", note: "长期使用、同一设备、同一地区，账户接管风险低。家庭电脑仍可能感染恶意软件。" },
      { label: "手机原生移动网络（大型运营商）", risk: "低至中低", note: "属自然使用场景。IP 经常变化，城市定位可能不准；漫游 eSIM 的出口可能在另一个国家。" },
      { label: "酒店 / 机场 / 咖啡馆公共 Wi-Fi", risk: "低至中等", note: "银行主要看到公共出口 IP。已知设备 + 官方 App + MFA 登录时，账户接管风险为中等；若新增收款人或大额转账，组合风险会大幅上升。" },
      { label: "一般商业 VPN", risk: "中等至中高", note: "已知机房 ASN、出口 IP 被大量用户共用、有匿名服务标记。若客户长期固定使用同一 VPN，风控模型可能已学习为正常行为。" },
      { label: "机房 / VPS 出口", risk: "中高至高", note: "诈骗者容易大量租用，与一般消费者登录环境差异大。NIST 将云服务 IP 列为可能触发额外风控的信号。" },
      { label: "住宅代理", risk: "中等至高（差异极大）", note: "IP 被归类为住宅不代表用户真的住在那里。使用历史无法掌控，与设备/位置矛盾并快速轮换时最危险。" },
      { label: "Tor", risk: "极高", note: "Tor 出口节点公开且被大量匿名用户共用，被各大金融风控系统标记。Microsoft 将 Tor 明确列为匿名 IP 风险类型。" },
      { label: "真实海外 IP（真的在旅行）", risk: "取决于整体情境", note: "真实海外 IP 本身不等于欺诈。风险取决于：是否为已知设备、验证强度、账户历史和交易类型。真实稳定的海外移动网络有时比频繁轮换的「美国住宅代理」更可信。" }
    ],
    scenarioTitle: "典型场景示意风险",
    riskFactor: "危险系数",
    scenarioNote: "以下不是任何机构的真实评分，仅用于说明：同一个 IP，在不同设备、验证方式和交易情境下，可能得到完全不同的风险评价。",
    scenarios: [
      { scenario: "已知手机 + 原生移动网络 + Passkey + 查看余额", risk: "5–15" },
      { scenario: "已知电脑 + 家庭宽带 + MFA + 正常使用", risk: "5–20" },
      { scenario: "已知手机在海外 + 当地移动网络", risk: "15–30" },
      { scenario: "已知设备 + 酒店 Wi-Fi + 正常登录", risk: "20–35" },
      { scenario: "已知设备 + 商业 VPN + 无敏感操作", risk: "30–50" },
      { scenario: "新设备 + 新国家 + 住宅宽带 + 强验证", risk: "35–55" },
      { scenario: "机房 VPN + 新设备 + 密码 + SMS OTP", risk: "55–75" },
      { scenario: "美国住宅代理 + 位置与设备历史严重矛盾", risk: "60–85" },
      { scenario: "新设备 + 新国家 + 刚重置密码 + 新增收款人", risk: "70–90" },
      { scenario: "Root/模拟器设备 + 远程控制 + 自动化操作", risk: "80–95" },
      { scenario: "Tor + 新设备 + 密码登录 + 大额转账", risk: "90–100" }
    ],
    conclusion: "许多人以为只要用「住宅 IP」就能安全登录海外网银，这其实是个迷思。现代风控系统看重的是「信任链」：常用的设备、无异常的网络、双重验证，以及符合历史习惯的操作。与其刻意把表面信号伪装得天衣无缝，不如保持真实且稳定的连接。在安全工程的角度里，「真实与规律」永远比「刻意伪装」来得可靠。",
    limits: [
      "IP 数据库可能存在延迟或缺失。",
      "地理位置是近似值，也可能代表网络出口节点。",
      "动态和移动网络 IP 可能快速变化。",
      "金融机构还会使用本工具无法呈现的更多私有信号。",
      "结果不代表任何平台的内部判断。"
    ]
  },
  esim: {
    eyebrow: "CAYLET eSIM",
    title: "准备跨国旅行？使用 Caylet eSIM 保持移动网络连接。",
    body: "探索面向国际旅行的数字流量方案。网络路由和出口位置会随套餐与运营商而变化。",
    cta: "探索 Caylet eSIM"
  },
  education: {
    eyebrow: "工作原理",
    title: "明确区分观察结果与预测",
    items: [
      { title: "连接", body: "Cloudflare 提供本网站可见的公网 IP 与网络元数据。" },
      { title: "信誉", body: "Scamalytics 可能依据自身数据集提供评分与结构化指标。" },
      { title: "浏览器", body: "浏览器提供本地环境信息；Caylet 不创建持久设备指纹。" }
    ]
  },
  faq: {
    title: "常见问题",
    items: [
      {
        q: "这项 IP 检测会显示什么？",
        a: "显示 Cloudflare 观察到的公网 IP、近似网络信息、浏览器提供的信息及可用的第三方信誉指标。"
      },
      {
        q: "结果能预测银行或支付平台的决定吗？",
        a: "不能。相关机构会使用更多非公开信号，本结果不代表或预测其内部审核。"
      },
      {
        q: "Caylet 会跟踪我的设备吗？",
        a: "不会创建持久设备标识。扫描结果仅保留在当前标签页内存中，只会保存语言偏好。"
      }
    ]
  },
  disclaimer: {
    title: "免责声明",
    body: "本教育工具只报告公开网络特征及第三方数据库结果，不能预测、代表、绕过或影响任何银行、发卡机构、支付平台或金融机构的内部风控。"
  },
  recommendations: {
    sectionEyebrow: "次要实验性分析",
    sectionTitle: "实验性场景适用度分析",
    sectionSubtitle: "根据可观察的网络与浏览器信号提供次要估算，并非对任何平台进行实时访问测试。",
    methodologyButton: "了解工具与评分逻辑",
    methodologyDialog: {
      title: "Caylet IP 如何运作",
      intro: "Caylet IP 综合了 Cloudflare 边缘网络数据、第三方信誉数据库，以及您的浏览器特征来进行评估。本工具仅针对您“当下的连接状态”进行客观分析，不会收集个人隐私，也无法绝对代表各大网络平台的最终风控结果。",
      processTitle: "检测会观察什么",
      process: [
        {
          title: "连接信息",
          body: "获取自 Cloudflare 边缘节点所观察到的公网 IP 与网络特征，确保数据真实性，无法手动输入其他 IP。"
        },
        {
          title: "信誉数据源",
          body: "整合 Scamalytics、AbuseIPDB、IP2Location 等多家威胁情报数据库。我们仅在后端进行数据比对，不会将原始 API 凭证暴露给浏览器。"
        },
        {
          title: "浏览器特征",
          body: "检测您的时区、操作系统、屏幕分辨率、硬件信号及 WebRTC 状态，这些数据仅在内存中进行瞬时比对，不会被永久存储。"
        },
        {
          title: "地区服务可用性",
          body: "针对 ChatGPT、Claude、TikTok 等主流服务，交叉比对您的 IP 所在地区是否支持。未列出的服务则不予评估。"
        }
      ],
      fraudTitle: "IP 欺诈评分",
      fraudBody: evidenceZhCN.reputationNote,
      recommendationTitle: "场景适用度",
      recommendationBody: "我们通过一系列规则来评估您的网络环境是否适合特定场景（如社交媒体或 AI 服务）。评估维度包含：IP 信誉、网络属性、环境一致性、浏览器特征及地区限制。为求严谨，当系统收集到的数据过少（可信度低于 40%）时，我们将不会显示具体分数；若可信度介于 40–59%，分数将标示为“有限估算”；而唯有可信度达到 85% 以上，才有可能获得最高等级的安全评级。",
      gradesTitle: "分数区间（可信度达到 40% 后显示）",
      grades: [
        "85–100：非常适合",
        "70–84：较适合",
        "55–69：一般／可以尝试",
        "40–54：风险偏高",
        "0–39：不建议"
      ],
      sourcesTitle: "地区可用性资料来源",
      sourcesIntro: "这些链接只支持具名服务的地区结论，并不表示本工具已从当前浏览器实时连接相应服务。",
      sourceVerified: "复核于 {date}",
      limitsTitle: "重要限制",
      limits: [
        "供应商记录与近似地理位置可能不完整、延迟或存在错误。",
        "数据中心标记为否，并不能证明 IP 属于住宅、移动网络或可信连接。",
        "浏览器观察只提供有限信号，不能证明身份、安全性或隐私状态。",
        "本工具不会执行 DNS 泄漏检测。",
        "结果不能预测银行、支付服务商、社交平台或 AI 服务的决定。"
      ],
      modelNote: "本页说明当前实现的实验性模型（版本 1.6.0）。每张推荐卡会列出实际因素、可信度、缺失数据与分数上限。"
    },
    socialMediaTitle: "社交媒体网络环境适用度",
    aiSoftwareTitle: "AI 服务网络环境适用度",
    disclaimer: "此实验性分析不会连接、登录或实时测试任何具名平台，也不代表平台官方判定。账户历史、设备记录、服务政策变化和使用行为都可能令实际结果不同。",
    confidenceLabel: "评估可信度",
    confidenceModal: {
      title: "评估可信度计算明细",
      subtitle: "展示各维度权重覆盖率与上限约束规则的计算过程。",
      rawScoreLabel: "原始数据覆盖得分",
      finalScoreLabel: "最终评估可信度",
      earnedLabel: "已获取",
      missingLabel: "未获取",
      items: {
        fraudScore: "Caylet 综合 IP 风险分值 (12%)",
        networkType: "网络类型判定 (12%)",
        proxy: "Proxy 代理检测标记 (8%)",
        vpn: "VPN 连接检测标记 (8%)",
        tor: "Tor 匿名网络标记 (8%)",
        hosting: "Datacenter 数据中心检测 (8%)",
        residentialProxy: "住宅代理风控标记 (8%)",
        ipCountry: "IP 地理位置国家 (6%)",
        ipTimezone: "IP 所在时区 (5%)",
        browserTimezone: "设备系统时区 (5%)",
        automationDetected: "WebDriver 自动化检测 (8%)",
        webrtc: "WebRTC 公网 IP 观察 (6%)"
      },
      providerCapNote: "受单一 IP 数据供应商限制，最高可信度封顶为 80%。",
      privacyCapNote: "因核心风控字段缺失，最高可信度封顶为 55%。"
    },
    detailsToggle: "查看详细评分因子与分析",
    positiveTitle: "正面因素",
    warningTitle: "风险因素",
    missingTitle: "数据缺失",
    appliedCapsTitle: "触发最高分硬性上限",
    capMaxScore: "最高分限制为 {score} 分",
    methodologyTitle: "评分方法说明",
    methodologyBody: "此实验性启发式指标按使用场景评估不同的可观察维度。未知数据不会被当作安全；可信度低于 40% 时不显示数值适用度与进度条，40–59% 时明确标为有限估算，最高等级要求可信度至少达到 85%。",
    dimensions: {
      ipReputation: "IP 信誉评分",
      networkAuth: "网络身份属性",
      consistency: "环境一致性",
      deviceIntegrity: "设备与浏览器完整性",
      protocolIntegrity: "协议与泄漏状态",
      regionalAvailability: "服务地区可用性"
    },
    grades: {
      excellent: "非常适合",
      good: "较适合",
      moderate: "可以尝试",
      poor: "存在明显风险",
      high_risk: "不建议用于重要运营",
      insufficient_data: "数据不足"
    },
    confidenceLevels: {
      high: "高可信度",
      medium: "中等可信度",
      limited: "有限可信度",
      insufficient: "数据不足"
    },
    signals: {
      lowFraudScore: { label: "IP 信誉良好的记录", exp: "威胁数据库标识此 IP 风险分数较低 ({score}/100)，未见重大恶意活动记录。" },
      elevatedFraudScore: { label: "IP 风险评分偏高", exp: "威胁数据库标识此 IP 具有中高风险指数 ({score}/100)，可能曾参与异常网络活动。" },
      missingFraudScore: { label: "未取得 IP 风险评分", exp: "当前配置的评分来源没有提供有效的 IP 风险分值。" },
      osintBlocklistMatch: { label: "命中僵尸网络 C2 封锁名单", exp: "abuse.ch Feodo Tracker 推荐名单将此 IP 匹配为僵尸网络命令与控制基础设施。该辅助命中不会转换为风险概率，也不能用于判定 VPN、Proxy、Tor 或数据中心属性。" },
      mobileIsp: { label: "移动蜂窝网络", exp: "此 IP 属于移动蜂窝网络，接近普通用户日常连接特征。" },
      residentialIsp: { label: "家用住宅宽带网络", exp: "此 IP 属于家用住宅宽带网络，接近普通用户日常连接特征。" },
      hostingNetwork: { label: "数据中心与机房网络", exp: "此 IP 属于云服务器或数据中心机房 (Hosting)，非一般家用宽带出口。" },
      torNode: { label: "Tor 匿名洋葱网络出口", exp: "此 IP 经证实为 Tor 匿名节点出口，隐私高度匿名化。" },
      publicProxy: { label: "公开代理服务器 (Public Proxy)", exp: "此 IP 被标记为公开可访问的代理连接服务器。" },
      proxyDetected: { label: "Proxy 代理连接节点", exp: "连接经过 Proxy 代理服务器转发。" },
      residentialProxy: { label: "住宅代理节点 (Residential Proxy)", exp: "连接被标记为租用型住宅代理 (Residential Proxy)。" },
      vpnDetected: { label: "商业 VPN 跨区节点", exp: "连接经过 Known VPN 商业服务器加密转接。" },
      missingProxyCheck: { label: "未取得 Proxy 代理判定", exp: "未能从当前数据源确认 Proxy 状态。" },
      missingVpnCheck: { label: "未取得 VPN 判定", exp: "未能从当前数据源确认 VPN 状态。" },
      missingTorCheck: { label: "未取得 Tor 匿名判定", exp: "未能从当前数据源确认 Tor 节点状态。" },
      missingHostingCheck: { label: "未取得数据中心判定", exp: "未能从当前数据源确认 Hosting 属性。" },
      tzMatch: { label: "设备时区与 IP 位置符合", exp: "设备本机时区 ({tz}) 与 IP 出口地理时区完全一致。" },
      tzMismatch: { label: "设备时区与 IP 位置不一致", exp: "设备时区 ({browserTz}) 与 IP 所在地时区 ({ipTz}) 不符，可能使用了跨区代理或未调整时区。" },
      automationDetected: { label: "侦测到自动化操控标记", exp: "浏览器暴露了 WebDriver 或自动化测试框架痕迹。" },
      virtualGpu: { label: "虚拟机或软件模拟渲染器", exp: "显示芯片被识别为虚拟/软件渲染器 ({gpu})，常见于 VPS、云端模拟器或无头浏览器。" },
      noWebRtcLeak: { label: "未观察到额外 WebRTC 地址", exp: "本次有限观察未暴露另一个公网 IP，但不能据此证明不存在泄漏。" },
      webrtcLeakMismatch: { label: "WebRTC IP 不一致", exp: "WebRTC 接口暴露了另一个外部 IP ({ip})，与当前连接 IP 不匹配。" },
      aiRegionRestricted: { label: "具名 AI 服务受到地区限制", exp: "IP 地区 {country} 的官方地区清单显示不可用服务为：{unavailable}。" },
      aiRegionRestrictedLimited: { label: "具名 AI 服务受到地区限制", exp: "IP 地区 {country} 的官方地区清单显示不可用服务为：{unavailable}；有限支持为：{limited}。" },
      aiRegionPartial: { label: "具名 AI 服务覆盖不完整", exp: "IP 地区 {country} 的官方地区清单显示：不可用为 {unavailable}；可用为 {supported}。" },
      aiRegionSupported: { label: "具名 AI 服务列出此地区", exp: "目前官方地区清单已为此地区列出这些服务：{supported}。" },
      aiRegionUnknown: { label: "未验证特定 AI 服务地区可用性", exp: "此 IP 地区没有已维护的具名服务政策资料，不能只凭国家作出判定。" },
      socialRegionRestricted: { label: "具名国际社交服务受限", exp: "当前可追溯的访问资料显示，IP 地区 {country} 无法使用这些服务：{unavailable}。" },
      socialRegionPartial: { label: "TikTok 未在香港提供服务", exp: "TikTok 已退出香港市场；此结论不表示 Facebook、Instagram、X 或其他社交平台不可用。" },
      socialRegionUnknown: { label: "未验证社交服务地区可用性", exp: "此 IP 地区没有已维护的具名社交服务访问资料。" }
    },
    caps: {
      tor: "Tor 匿名洋葱网络出口节点",
      publicProxy: "公开 Proxy 代理服务器",
      proxy: "Proxy 代理服务器",
      residentialProxy: "租用型住宅代理节点 (Residential Proxy)",
      vpnHosting: "机房与 VPN 双重匿名连接",
      automation: "侦测到 WebDriver 自动化操控标记",
      fraudHigh: "IP 威胁分值极高 (Fraud Score >= 80)",
      fraudElevated: "IP 威胁分值偏高 (Fraud Score >= 65)",
      webrtcLeak: "WebRTC 暴露异地公开 IP",
      dualStackMismatch: "IPv4 与 IPv6 属不同出口国家",
      hostingSocial: "云服务器与数据中心 IP (Social Media)",
      hostingAi: "云服务器与数据中心 IP (AI Software)",
      socialServicesRestricted: "此 IP 地区的具名国际社交服务受限",
      socialServicesPartial: "TikTok 未在香港提供服务",
      aiServicesRestricted: "具名 AI 服务受到地区限制",
      aiServicesPartial: "具名 AI 服务覆盖不完整"
    },
    summaries: {
      insufficient: "当前证据不足，无法形成可靠的适用度评估。请查看下方数据缺失说明；界面不会显示数值分数。",
      withWarnings: "环境展现出 {positives}，但受 {warnings} 影响，相对适合度受到一定限制。",
      optimal: "当前可用信号中未发现明显警示，但缺失检测项与供应商覆盖仍会限制此启发式结果。",
      fallbackPositives: "基础环境特征"
    }
  },
  privacyModal: {
    title: "隐私政策 — Caylet IP",
    body: "Caylet IP (ip.caylet.com) 是由 Caylet LLC 提供、以隐私为核心的教育型网络诊断工具。\n\n1. 数据处理：我们仅分析 Cloudflare 边缘网络观察到的公网 IP 地址、连接元数据与网络信号，用于实时生成检测诊断报告。\n\n2. 本地浏览器环境：设备特征（如时区、屏幕分辨率、GPU 显示芯片、WebRTC 候选 IP）完全在您的浏览器标签页内存中处理。\n\n3. 无持久跟踪：我们不会创建持久设备指纹、不跟踪浏览行为，也不使用跨站 Cookie。仅在浏览器本地保存您的语言偏好设置。\n\n4. 第三方服务：信誉评分可能检索自 Scamalytics 与 AbuseIPDB 等公开情报库，我们不会向第三方透露您的个人身份信息。"
  },
  termsModal: {
    title: "使用条款 — Caylet IP",
    body: "当你访问或使用 Caylet IP (ip.caylet.com) 时，即表示你同意以下条款：\n\n1. 教育与诊断用途：本网站提供的网络特征与风控指标仅供教育参考与网络诊断使用。\n\n2. 不代表金融机构决定：检测结果不能预测、代表、绕过或影响任何银行、发卡机构、支付平台或金融机构的内部风控判断。\n\n3. 规范合理使用：严禁任何自动化滥用、绕过请求速率限制或恶意抓取本服务。\n\n4. 免责声明：Caylet LLC 按“现状 (As-Is)”提供本诊断工具，不提供任何明示或暗示之担保。"
  },
  footer: {
    privacy: "隐私政策",
    terms: "使用条款",
    copyright: "© 2024-{year} Caylet LLC. All Rights Reserved.",
    privacyStatement: "本网站不会收集个人数据、存储用户指纹或设置非必要 Cookie。使用部分 API 时可能会向第三方发出最低限度的请求，分析工具等第三方服务也可能暂时启用。"
  },
  articles: {
    title: "科普文章",
    subtitle: "了解 IP、网络环境、代理侦测、浏览器指纹与平台风控的基本原理。",
    emptyState: "科普文章正在整理中。你仍然可以先使用 Caylet IP 检测工具分析目前的网络环境。",
    backToTool: "返回 IP 检测工具",
    readTime: "分钟阅读",
    lastUpdated: "最后更新",
    published: "发布于",
    related: "相关文章",
    tableOfContents: "目录",
    sources: "资料来源",
    faq: "常见问题",
    featured: "精选文章",
    all: "全部文章"
  },
  errors: {
    generic: "网络检测未能完成，但本地浏览器信息仍可查看。",
    invalid: "服务拒绝了无效请求。",
    rateLimited: "短时间内请求过多，请稍后再试。",
    turnstile: "请完成验证后重试。"
  },
  a11y: {
    skip: "跳至主要内容",
    menu: "打开导航",
    scannerStatus: "IP 检测状态",
    external: "在新标签页打开",
    info: "更多信息"
  },
  seo: {
    title: "我的 IP 是什么？IP 信誉与网络环境检测 | Caylet",
    description: "检测公网 IP、近似位置、ASN、网络服务商、浏览器环境及 Scamalytics IP 信誉指标。"
  }
} satisfies Messages;
